import React from "react";
import { useField } from "formik";
import { TextField, MenuItem, Box, Typography } from "@mui/material";

interface Props {
  placeholder: string;
  name: string;
  options: any[];
  label?: string;
  required?: boolean;
}

export default function CustomSelectInput(props: Props) {
  const [field, meta, helpers] = useField(props.name);
  const showError = meta.touched && meta.error;

  return (
    <Box sx={{ mb: 2 }}>
      <TextField
        select
        fullWidth
        variant="standard"
        label={props.placeholder}
        value={field.value ?? ""}
        onChange={(e) => {
          const raw = e.target.value as any;
          const selected = props.options?.find((o: any) => String(o.value) === String(raw));
          helpers.setValue(selected ? selected.value : raw);
        }}
        onBlur={() => helpers.setTouched(true)}
        error={!!showError}
      >
        {props.options?.map((opt: any) => (
          <MenuItem key={opt.value ?? opt.key} value={opt.value}>
            {opt.text}
          </MenuItem>
        ))}
      </TextField>
      {showError && (
        <Typography color="error" variant="caption">
          {meta.error}
        </Typography>
      )}
    </Box>
  );
}
